import React, { useEffect } from 'react';
import styled from 'styled-components';

import Modal from '~/atomic/molecula/Modal';
import { forgot } from '~/feature/authorization/auth.data';
import { authModalActions, openModal } from '~/feature/authorization/authorizationModal.slice';
import { QuickLoginForm } from '~/feature/authorization/quickAuth/QuickLoginForm';
import { choosePaySelector } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.selector';
import { activateCatalogTimerDiscount } from '~/feature/withTiwerDiscount/activateCatalogTimerDiscount/activateCatalogTimerDiscount.data';
import { activateCatalogTimerDiscountSelector } from '~/feature/withTiwerDiscount/activateCatalogTimerDiscount/activateCatalogTimerDiscount.selector';
import { activateCatalogTimerDiscountActions } from '~/feature/withTiwerDiscount/activateCatalogTimerDiscount/activateCatalogTimerDiscount.slice';
import { ym } from '~/feature/yandex/YandexMetrikaInit';
import { lessThan } from '~/lib/mediaQuery';
import { useAppDispatch, useAppSelector } from '~/store';

export const LoginModalWithActivateCatalogTimerDiscount = () => {
  const dispatch = useAppDispatch();
  const { isOpenLoginModalWithActivateCatalogTimerDiscount } = useAppSelector(activateCatalogTimerDiscountSelector);
  const { quickAuthEmail } = useAppSelector(choosePaySelector);

  useEffect(() => {
    if (isOpenLoginModalWithActivateCatalogTimerDiscount) {
      ym('reachGoal', 'open-login-modal');
    }
  }, [isOpenLoginModalWithActivateCatalogTimerDiscount]);

  const closeModal = () => {
    dispatch(activateCatalogTimerDiscountActions.setIsOpenLoginModalWithActivateCatalogTimerDiscount(false));
  };

  const afterLoginHandler = () => {
    closeModal();
    dispatch(activateCatalogTimerDiscount());
  };

  const onRecoveryClick = async () => {
    await dispatch(forgot({ email: quickAuthEmail }));
    dispatch(authModalActions.setSuccessRecovery(true));
    dispatch(openModal('recovery'));
    closeModal();
  };

  const onBackClick = () => {
    closeModal();
    dispatch(activateCatalogTimerDiscountActions.setIsOpenAuthModalWithActivateCatalogTimerDiscount(true));
  };

  return (
    <SCAuthModal
      onCancel={closeModal}
      open={isOpenLoginModalWithActivateCatalogTimerDiscount}
    >
      <QuickLoginForm
        onBackClick={onBackClick}
        email={quickAuthEmail}
        afterLogin={afterLoginHandler}
        onRecoveryClick={onRecoveryClick}
        nextButtonText="Войти"
      />
    </SCAuthModal>
  );
};

export const SCAuthModal = styled(Modal)`
  max-width: 458px;

  .ant-modal-body {
    padding-top: 23px;
    padding-bottom: 23px;
  }

  ${lessThan('xs')} {
    max-width: 100vw;
    top: 0;
  }
`;
